module.exports = __webpack_public_path__ + "images/Logo group SPG_Rytz-54a3f931fbf8f1074b32a88ff412417a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logo group SPG_Rytz.jpg
// module id = 28
// module chunks = 0